"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;

var _rcSlider = require("rc-slider");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Inner = function Inner(props) {
  return _react.default.createElement(_rcSlider.Range, _extends({}, props, {
    prefixCls: props.className
  }));
};

Inner.displayName = "Inner";

/**
 * A slider component that allows to define a range of values. nin and max
 */
var Slider = (0, _styledComponents.default)(Inner).withConfig({
  displayName: "Slider",
  componentId: "dqhabm-0"
})(["", ";", ";box-sizing:border-box;position:relative;height:", "px;border-radius:", "px;background-color:", ";&-track{position:absolute;left:0;top:0;height:", "px;border-radius:", "px;background-color:", ";z-index:1;transition:background-color 0.25s;}&-handle{position:absolute;margin-left:-10px;margin-top:-8px;top:0;width:", "px;height:", "px;cursor:pointer;border-radius:50%;border:solid 2px ", ";background-color:", ";z-index:2;transition:background-color 0.25s;pointer-events:", ";&:first-child{margin-left:", "px;}&:last-child{margin-left:-", "px;}&:hover{border-color:", ";}&-active{&:active{border-color:", ";box-shadow:0 0 5px ", ";}}}&-dot{position:absolute;bottom:-", "px;margin-left:-", "px;width:", "px;height:", "px;border:2px solid ", ";background-color:", ";cursor:pointer;border-radius:50%;vertical-align:middle;&:first-child{margin-left:-", "px;}&:last-child{margin-left:-", "px;}&-active{border-color:", ";}}"], _styledSystem.borders, _styledSystem.space, (0, _helpers.space)(0.5), (0, _helpers.space)(0.5), (0, _helpers.color)("black10"), (0, _helpers.space)(0.5), (0, _helpers.space)(0.5), function (props) {
  return props.disabled ? (0, _helpers.color)("black10") : (0, _helpers.color)("black100");
}, (0, _helpers.space)(2), (0, _helpers.space)(2), (0, _helpers.color)("white100"), function (props) {
  return props.disabled ? (0, _helpers.color)("black10") : (0, _helpers.color)("black100");
}, function (props) {
  return props.disabled ? "none" : "auto";
}, (0, _helpers.space)(1), (0, _helpers.space)(1), (0, _helpers.color)("black100"), (0, _helpers.color)("black100"), (0, _helpers.color)("black100"), (0, _helpers.space)(0.5), (0, _helpers.space)(1), (0, _helpers.space)(2), (0, _helpers.space)(2), (0, _helpers.color)("black100"), (0, _helpers.color)("black100"), (0, _helpers.space)(0.5), (0, _helpers.space)(0.5), (0, _helpers.color)("black60"));
exports.Slider = Slider;
//# sourceMappingURL=Slider.js.map